module.exports = __webpack_public_path__ + "img/add.aa922b9a.svg";